module.exports = __webpack_public_path__ + "static/altana-zima_thumb-63dd94094ac3eff6b284a4b3a27a6562.jpg";